import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { isInternalTraffic } from "./analytics";
import { analyticsActive, onConsentChange } from "./consent";

/** Fires a GA4 page_view on every SPA route change — only once analytics consent is active.
 *  When consent is granted mid-session the current page is reported immediately. Skips /admin. */
export const useGtagPageviews = () => {
  const location = useLocation();
  const lastPath = useRef(null);
  const [consentTick, setConsentTick] = useState(0);

  useEffect(() => onConsentChange(() => setConsentTick((n) => n + 1)), []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!analyticsActive() || typeof window.gtag !== "function" || !window.GA_MEASUREMENT_ID) return;

    const path = location.pathname + location.search;
    if (path === lastPath.current) return;
    if (location.pathname.startsWith("/admin")) return;
    lastPath.current = path;

    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: window.GA_MEASUREMENT_ID,
      ...(isInternalTraffic() ? { traffic_type: "internal" } : {}),
    });
  }, [location.pathname, location.search, consentTick]);
};

export default useGtagPageviews;
